import { render, staticRenderFns } from "./AcademyBanner.vue?vue&type=template&id=7e3e0104&scoped=true"
var script = {}
import style0 from "./AcademyBanner.vue?vue&type=style&index=0&id=7e3e0104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3e0104",
  null
  
)

export default component.exports